"use client"

import { DefaultImage } from "@/lib/external-components"
import { getLocalizedHref } from "@/lib/locale-utils"
import { toImageSrc } from "@/lib/utils"
import { PostData } from "@/types/types"
import Image from "next/image"
import Link from "next/link"
import { useState } from "react"

interface PostCardItemProps {
  post: PostData
  isDragging?: boolean
}

export const PostCardItem: React.FC<PostCardItemProps> = ({ post, isDragging }) => {
  const [hasMoved, setHasMoved] = useState(false)
  const [startPos, setStartPos] = useState({ x: 0, y: 0 })
  // Slug thuộc locale nào thì URL theo locale đó → lấy thẳng từ chính bài.
  const locale = post.attributes.locale

  const handleMouseDown = (e: React.MouseEvent) => {
    setStartPos({ x: e.clientX, y: e.clientY })
    setHasMoved(false)
  }

  const handleMouseMove = (e: React.MouseEvent) => {
    const deltaX = Math.abs(e.clientX - startPos.x)
    const deltaY = Math.abs(e.clientY - startPos.y)

    if (deltaX > 5 || deltaY > 5) {
      setHasMoved(true)
    }
  }

  const handleClick = (e: React.MouseEvent) => {
    if (hasMoved || isDragging) {
      e.preventDefault()
      e.stopPropagation()
    }
  }

  const content = (
    <>
      <div className="relative h-[280px] rounded-lg w-full">
        <Image
          src={toImageSrc(post.attributes.image?.data?.attributes?.url) || DefaultImage}
          alt={post.attributes.name || ""}
          fill
          className="object-cover rounded-lg w-full h-full hover-image hover:scale-[1.01] transition-transform duration-300"
        />
      </div>
    </>
  )

  return (
    <div
      key={post.id}
      className="flex-shrink-0 w-full"
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
    >
      <Link
        href={getLocalizedHref(locale, post.attributes.slug)}
        className="flex flex-col gap-4 group hover:opacity-90 transition-all duration-300"
      >
        {content}
      </Link>
    </div>
  )
}

export default PostCardItem
